import React, { useState } from "react";
import Text from "components/common/Text";
import Box from "components/common/Box";
import { InputLabel } from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "components/common/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Dialog from "components/common/DialogMD";
import DatePickerModal from "components/common/DatePickerModal";
import Stack from "@mui/material/Stack";
import InputAdornment from "@mui/material/InputAdornment";
import EventIcon from "@mui/icons-material/Event";
import { makeStyles } from "@mui/styles";

const DashboardOverview = ({
  state,
  data,
  onchange,
  onclick,
  open,
  onClose,
  handleChange,
  props,
  formData,
  vendorname,
  onDatePickerSub,
  handleReset
}) => {
  const classes = useStyles();
  const [custom, setCustom] = useState("");

  const dateType = [
    { value: "Current Month", key: "Current Month" },
    { value: "day", key: "Last 24 hours" },
    { value: "week", key: "Last week" },
    { value: "month", key: "Last Month" },
    { value: "year", key: "Last year" },
    { value: "custom", key: "Custom" },
  ];

  let vehModels = props.vehicleMasterData;
  let locationDatas = props.locationData;
  let manufacturerDatas = props.manufacturerData;
  return (
    <>
      <Text
        variant="h5"
        className={classes.pageHeading}
        gutterBottom
        sx={{
          fontSize: "22px",
          fontWeight: "600",
          marginTop: "15px",
          marginLeft: "12px",
          color: "#545454",
        }}
      >
        OVERVIEW
      </Text>
      <Stack
        direction={{ sm: "column", xs: "column", md: "row" }}
        spacing={1}
        className={classes.overview_container}
      >
        <Stack
          direction={{ sm: "column", xs: "column", md: "row" }}
          spacing={0.5}
        >
          <Box sx={{ minWidth: 155 }}>
            <FormControl fullWidth size="small">
              <InputLabel sx={{ fontSize: "15px" }} id="Vendor-label">
                Vendor
              </InputLabel>
              <Select
                labelId="location-label"
                label="Vendor"
                className={classes.overview_container_location}
                value={formData.vendor_id ? formData.vendor_id : "all"}
                onChange={(e) => onchange("vendor_id", e.target.value)}
              >
                <MenuItem sx={{ fontSize: "14px" }} selected value={"all"}>
                  All
                </MenuItem>
                {vendorname?.map((ven) => (
                  <MenuItem
                    sx={{ fontSize: "14px" }}
                    key={ven.vendor_id}
                    value={ven.vendor_id}
                  >
                    {ven.vendors_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ minWidth: 155 }}>
            <FormControl fullWidth size="small">
              <InputLabel sx={{ fontSize: "15px" }} id="location-label">
                Location
              </InputLabel>
              <Select
                labelId="location-label"
                label="Location"
                className={classes.overview_container_location}
                value={formData.station_id ? formData.station_id : "all"}
                onChange={(e) => onchange("station_id", e.target.value)}
              >
                <MenuItem sx={{ fontSize: "14px" }} selected value={"all"}>
                  All
                </MenuItem>
                {locationDatas.map((locs) => (
                  <MenuItem
                    sx={{ fontSize: "14px" }}
                    key={locs.id}
                    value={locs.id}
                  >
                    {locs.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ minWidth: 155 }}>
            <FormControl fullWidth size="small">
              <InputLabel sx={{ fontSize: "15px" }} id="manufacturer-label">
                Manufacturer
              </InputLabel>
              <Select
                labelId="manufacturer-label"
                label="Manufacturer"
                sx={{ height: "42px", backgroundColor: "white" }}
                className={classes.overview_container_location}
                value={
                  formData.manufacturer_id ? formData.manufacturer_id : "all"
                }
                onChange={(e) => onchange("manufacturer_id", e.target.value)}
              >
                <MenuItem sx={{ fontSize: "14px" }} value={"all"}>
                  All
                </MenuItem>
                {manufacturerDatas.map((manufacturers) => (
                  <MenuItem
                    sx={{ fontSize: "14px" }}
                    key={manufacturers.id}
                    value={manufacturers.id}
                  >
                    {manufacturers.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ minWidth: 155 }}>
            <FormControl fullWidth size="small">
              <InputLabel sx={{ fontSize: "15px" }} id="model55abel">
                Model
              </InputLabel>
              <Select
                labelId="model-label"
                label="Model"
                sx={{ height: "42px", backgroundColor: "white" }}
                className={classes.overview_container_location}
                value={formData.model_id ? formData.model_id : "all"}
                onChange={(e) => onchange("model_id", e.target.value)}
              >
                <MenuItem sx={{ fontSize: "14px" }} value={"all"}>
                  All
                </MenuItem>
                {vehModels.map((modls) => (
                  <MenuItem
                    sx={{ fontSize: "14px" }}
                    key={modls.id}
                    value={modls.id}
                  >
                    {modls.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ minWidth: 155 }}>
            <FormControl fullWidth size="small">
              <InputLabel sx={{ fontSize: "14px" }} id="location-label">
                Select Date
              </InputLabel>
              <Select
                labelId="location-label"
                label="Select Date"
                className={classes.overview_container_location}
                value={custom ? custom : "Current Month"}
                onChange={(e, value) => {
                  setCustom(e.target.value);
                  onchange(e.target.value);
                }}
              >
                {dateType.map((date) => (
                  <MenuItem
                    sx={{ fontSize: "14px" }}
                    key={date.value}
                    value={date.value}
                  >
                    {date.key}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          {custom == "custom" ? (
            <Box sx={{ minWidth: 155 }}>
              <FormControl fullWidth size="small">
                <InputLabel sx={{ fontSize: "14px" }} id="daterange-label">
                  Date Range
                </InputLabel>
                <OutlinedInput
                  label="Date Range"
                  sx={{
                    fontSize: "10px !important",
                    height: "35px !important",
                    fontWeight: "600",
                    backgroundColor: "white",
                  }}
                  id="outlined-adornment-amount"
                  value={
                    state.formData.from_date && state.formData.to_date
                      ? `${state.formData.from_date} - ${state.formData.to_date}`
                      : ""
                  }
                  onClick={onclick}
                  endAdornment={
                    <InputAdornment position="end" sx={{cursor:'pointer'}}>
                      <EventIcon />
                    </InputAdornment>
                  }
                  disabled
                />
              </FormControl>
            </Box>
          ) : null}

          <Dialog
            open={open}
            onClose={onClose}
            children={
              <DatePickerModal
                onClose={onClose}
                onDatePickerSub={onDatePickerSub}
                from_date={state.formData.from_date}
                to_date={state.formData.to_date}
                handleChange={handleChange}
                handleReset={handleReset}
                onClickDay={(item) => {}}
              />
            }
            title="Select a date range"
          />
        </Stack>
      </Stack>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  overview_container: {
    marginLeft: "1rem",
    marginTop: "1rem",
    fontFamily: "Nunito Sans",
    color: "#707070",
    ["@media (max-width:768px)"]: {
      width: "100%",
    },
  },

  overview_container_location: {
    height: "36px",
    backgroundColor: "white",
    width: "150px",
    fontSize: "14px",
    ["@media (max-width:768px)"]: {
      width: "100%",
    },
  },

  pageHeading: {
    ["@media (max-width:768px)"]: {
      fontSize: "20px",
      width: "100%",
      padding: "5px",
    },
  },
}));

export default DashboardOverview;
